




























































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import SheetListTab from "../../components/SheetListTab.vue";
import AlertArea from "../../components/AlertArea.vue";
import { Sheet, ResultListCondition } from "../../modules/teacher/ResultList"


export interface Data {
  tabNo: number
  condition: ResultListCondition
  comboboxKinds: any[]
  sheets: Sheet[]
  totalCount: number
  KindEnum: Readonly<{TwentyMin: number; Various: number; Kimatsu: number}>
  errors: string[]
  isShow: boolean
}

export default defineComponent({
  components: {
    "sheet-list-tab": SheetListTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * ref
     ******************************/

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      tabNo: 3,
      condition: context.root.$store.state.resultListCondition,
      comboboxKinds: context.root.$store.getters.getComboboxKinds(true).filter((x: any) => x.value != Common.KindEnum.Kimatsu),
      sheets: new Array<Sheet>(),
      totalCount: 0,
      KindEnum: Common.KindEnum,
      errors: [],
      isShow: false,
    });

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.condition.page = 1;
      search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/result_list?${Common.BuildQuery(state.condition, 'search_sheet')}`).then(response => {
        state.sheets = response.data.sheets.map((x: any) => new Sheet(x));
        state.totalCount = state.sheets.length > 0 ? state.sheets[0].at_full_count : 0;

        context.root.$store.commit("setResultListCondition", state.condition);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * 順位順Excelダウンロード
     ************************************************************/

    const downloadRankExcel = async (sheet: Sheet): Promise<void> => {

      context.root.$store.dispatch("showOverlay");
      await http.get(`/api/result_list/download_rank/${sheet.sheet_group_key}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = "諸テスト_学年一覧（順位順）.xlsx";
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 番号順Excelダウンロード
     ************************************************************/

    const downloadNumberExcel = async (sheet: Sheet): Promise<void> => {

      context.root.$store.dispatch("showOverlay");
      await http.get(`/api/result_list/download_number/${sheet.sheet_group_key}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = "諸テスト_学年一覧（番号順）.xlsx";
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 実施日を画面表示文言にコンバート
     ******************************/

    const convertExecDate = (execDate: string) => {
      return execDate ? moment(execDate).format('M月') : "-";
    };

    /******************************
     * クリアボタン押下
     ******************************/

    const clearCondition = () => {
      state.condition = new ResultListCondition();
    };

    /******************************
     * クラスボタン押下
     ******************************/

    const toRoomClick = (sheet: Sheet, room_id: number, nendo: number) => {
      context.root.$store.commit("setCurrentNendo", nendo);
      context.root.$router.push(`/teacher_site/result_student_list/${sheet.sheet_group_key}/${room_id}`).catch(() => {});
    };

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      search();
    };

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      if(context.root.$store.state.resultListCondition == null){
        state.condition = new ResultListCondition();
        state.condition.nendo = context.root.$store.getters.getCurrentNendo();
      }else{
        state.condition = context.root.$store.state.resultListCondition;
      }
      await search();
      state.isShow = true;
    });

    return {
      ...toRefs(state),
      search,
      searchClick,
      downloadRankExcel,
      downloadNumberExcel,
      convertExecDate,
      clearCondition,
      toRoomClick,
      changePage,
    }
  }
});
